<template>
  <el-row class="logapp">
    <div class="logapp-container">
      <div class="logapp-panel">
        <div class="logapp-logo"></div>
        <el-form ref="formLogin" :model="formLogin" label-width="120px">
          <el-form-item>
            <el-input placeholder="e-mail" v-model="formLogin.email" @input="forceLowerCase" />
          </el-form-item>
          <el-form-item>
            <el-input placeholder="Mot de passe" type="password" show-password v-model="formLogin.password" />
          </el-form-item>
          <el-button type="primary" @click="login">Connexion</el-button>
          <div class="logapp-message">
            <span v-if="!loggError">
              Bienvenue dans votre<br>
              application {{ nameApp }}.<br>
              <span>La révolution est en marche.</span>
            </span>
            <span v-else style="color:#f13030">
              Votre login ou mot de passe<br>
              semblent erronés.<br>
              Merci de les vérifier.
            </span>
          </div>
        </el-form>
      </div>
    </div>
  </el-row>
</template>

<script>
export default {
  name: 'Login',
  data: function () {
    return {
      formLogin: {
        email: '',
        password: ''
      },
      nameApp: 'Resa.Ninja',
      userId: '',
      loggError: false
    }
  },
  methods: {
    login: function () {
      let userLogin = {
        email: this.formLogin.email,
        password: this.formLogin.password
      }
      this.$store.dispatch('newUsers/login', userLogin).catch(err => {
        console.error('Impossible de ce connecter', err)
        this.loggError = true
      })
    },
    forceLowerCase: function (e) {
      this.formLogin.email = this.formLogin.email.toLowerCase()
    },
    resetPass: function () {
      this.$store.dispatch('newUsers/resetPass', this.formLogin.email)
    }
  }
}
</script>

<style lang="scss">
@use "../styles/components/layout/logapp";
</style>
